// Import model
import { AiChatCondition } from '../models/AiChatCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { AiChatIndexedFields } from '../models/AiChatIndexedFields';
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';

// Import dependency serializers (for complex types)
import { AiChatIndexedFieldsSerializer } from './AiChatIndexedFieldsSerializer';
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for AiChatCondition - handles JSON serialization and deserialization with type validation
 */
export class AiChatConditionSerializer {
  /**
   * Deserializes a JSON string into a AiChatCondition instance
   */
  static deserialize(json: string): AiChatCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a AiChatCondition instance
   */
  static fromObject(obj: any): AiChatCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to AiChatCondition');
    }


    const instance: AiChatCondition = {
      fieldName: obj['fieldName'] as AiChatIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of AiChatCondition instances
   */
  static deserializeArray(json: string): AiChatCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a AiChatCondition instance to a JSON string
   */
  static serialize(instance: AiChatCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a AiChatCondition instance to a plain object
   */
  static toObject(instance: AiChatCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of AiChatCondition instances to a JSON string
   */
  static serializeArray(instances: AiChatCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
